import React from 'react'

const MyList = () => {
  return (
    <div>
      My List
    </div>
  )
}

export default MyList
